export default __webpack_public_path__ + "static/media/icon_info_category_09.585f472d.svg";